import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import {computed} from "vue";
import {Phone, PhoneHangUp} from "utruckin-icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'callMessage',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props

const formattedTime = computed(() => {
  const totalSeconds = Number(props.item.duration) || 0

  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0')
  const seconds = String(totalSeconds % 60).padStart(2, '0')

  return `${hours}:${minutes}:${seconds}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["f-ui-call", __props.item.status === 'missed' || __props.item.status === 'rejected' ? 'error' : ''])
  }, [
    (__props.item.duration)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_unref(Phone), { size: 16 }),
          _createElementVNode("span", null, _toDisplayString(formattedTime.value), 1)
        ], 64))
      : (__props.item.status === 'missed')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(PhoneHangUp), { size: 16 }),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "Missed", -1))
          ], 64))
        : (__props.item.status === 'rejected')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_unref(PhoneHangUp), { size: 16 }),
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "Declined", -1))
            ], 64))
          : _createCommentVNode("", true)
  ], 2))
}
}

})